import React from 'react';
import AutocompleteInput from '../AutocompleteInput';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { styles } from './MenuSelect.styles';
import { mainColor } from '../../constants/theme';
import { ALL_POS_TYPES, PRODUCT_WITHOUT_REF } from '../../constants'
const MuiTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: mainColor.secondaryColor
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: mainColor.secondaryColor
        }
    }
})(TextField);
interface Item {
    key: string;
    [key: string]: any;
}

interface Props {
    data: any[];
    placeholder: string;
    onUpdate: (newValue: Item | '') => void;
    item: Item;
    disabled?: boolean;
    classes: any;
    noOptionsText: string;
    itemKey: string;
}

const MenuSelect: React.FC<Props> = ({ data, placeholder, onUpdate, classes, item, disabled = false, noOptionsText, itemKey }) => {
    const updatedItems: Item[] = [];
    _.map(data, item => {
        if (item.products) _.map(item.products, elt => {
            updatedItems.push({ [itemKey]: item?.name?.toUpperCase(), ...elt });
        })
        else
            _.map(item.items, elt => {
                updatedItems.push({ [itemKey]: item?.name?.toUpperCase(), ...elt });
            });
    });
    const uniqueItems = _.uniqBy(updatedItems, item => `${item.name}-${item.ref}`);
    if (itemKey === 'sectionName') {
        uniqueItems.unshift(PRODUCT_WITHOUT_REF)
    }

    return (
        <AutocompleteInput
            disabled={disabled}
            id={item.key}
            options={uniqueItems.sort((a, b) => -b.itemKey?.localeCompare(a.itemKey))}
            groupBy={item => item[itemKey]}
            getOptionLabel={(item) => `${item?.name} ${item.type ? `- ${ALL_POS_TYPES[item.type]}` : ''}`}
            renderOption={(item) => (
                <div>
                    <span>{item?.name}</span>
                    <small className={classes.text}>{item.type ? `- ${ALL_POS_TYPES[item.type]}` : ''}</small>
                </div>
            )}
            value={item.ref && uniqueItems.find(element => element.ref === item.ref)}
            className={classes.autocomplete}
            onChange={(e, newValue) => onUpdate(newValue ? newValue : '')}
            noOptionsText={noOptionsText}
            renderInput={params => (
                <MuiTextField
                    margin='dense'
                    {...params}
                    InputLabelProps={{ classes: { root: classes.label } }}
                    label={placeholder}
                />
            )}
        />
    );
};

export default withStyles((styles))(MenuSelect);
